module.exports = __webpack_public_path__ + "static/img/2.90aab26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/2.png
// module id = 0TSl
// module chunks = 0